module.exports = new __parcel__URL__("fcf_profile.4ba5e38a.svg").toString();